'use client'

import { useEffect, useState } from 'react'

/**
 * True quando l'utente ha chiesto al sistema di ridurre le animazioni
 * (`prefers-reduced-motion: reduce`).
 *
 * I caroselli lo usano per non avviare l'autoplay e per saltare le transizioni:
 * senza questa guardia il movimento continuo resta attivo anche per chi ha
 * disattivato le animazioni a livello di sistema operativo.
 *
 * Parte da `false` per non divergere dal markup server-rendered (hydration);
 * il valore reale viene letto subito dopo il mount e resta aggiornato.
 */
export function usePrefersReducedMotion(): boolean {
  const [reduce, setReduce] = useState(false)

  useEffect(() => {
    const query = window.matchMedia('(prefers-reduced-motion: reduce)')
    const update = () => setReduce(query.matches)
    update()
    query.addEventListener('change', update)
    return () => query.removeEventListener('change', update)
  }, [])

  return reduce
}
